import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {SeleccionInformesContainer} from './Screen';

export const SeleccionInformesView = () =>{

    return (
        <Page title={'Informes'} scrollBody>{<SeleccionInformesContainer/>}</Page>
    )
}